import { Component } from "@angular/core";

@Component({
    selector: "nbc-unauthorized",
    templateUrl: "./nbc-unauthorized.component.html",
    standalone: false
})
export class NbcUnauthorized {
    constructor() {}
}
